/**
 * Created by desheng.zhao on 2019/6/17.
 */
import Vue from 'vue';

const infoLog = {
  state: {
    infos: {}, // {home: [{info: "系统类型ios"}], {withdraw: [{info: "提现金额500"},{info: "总金额800"}]}}
  },
  mutations: {
    // 新增info   payload: {page: "首页",info: "调用接口成功"} => payload: {page: "首页",info: {message:"调用接口成功",page:"首页"}}
    addInfo(state, payload) {
      payload.info = {
        message: payload.info,
        page: payload.page
      };
      if(Array.isArray(state.infos[payload.page])){
        Vue.set(state.infos, payload.page, state.infos[payload.page].concat(payload.info))
      }else{
        Vue.set(state.infos, payload.page, [payload.info])
      }
    }
  },
  actions: {
    addInfo(state, payload) {
      state.commit("addInfo",payload);
    }
  },
  getters: {
    // 返回所有的info
    allInfo: function(state){
      let infos = [];
      const obj = state.infos;
      Object.keys(obj).forEach(item => {
        infos = infos.concat(obj[item]);
      });
      return infos;
    },
    // 按页面返回info
    pageInfo(state){
      return (page) => {
        return state.infos[page];
      }
    },
    // 返回有info的页面
    hasInfoPages(state){
      const obj = state.infos;
      return Object.keys(obj);
    }
  }
}

export default infoLog;


// WEBPACK FOOTER //
// ./src/store/infoLog.js